<template>
  <v-main app>
    <v-container
      class="horizontal-container rounded-lg relative grey lighten-5"
      style="margin-top: 80px !important;"
    >
      <top-nav-menu class="mb-4" />
      <v-expand-transition mode="out-in">
        <router-view />
      </v-expand-transition>
    </v-container>

    <div class="flex-grow-1" />
  </v-main>
</template>

<script>
  export default {
    components: {
      TopNavMenu: () => import('./TopNavMenu'),
    },
    data () {
      return {}
    },
    methods: {},
  }
</script>

<style lang="scss">
.v-main__wrap {
    flex: 1 1 auto;
    max-width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
}
.horizontal-container {
    z-index: 1;
}
</style>
